export const TRADES = [
  "Construction",
  "Steel Erector",
  "Electrician",
  "Truck Driver",
  "Plumber",
  "Welder",
  "Labourer",
  "Teleporter Driver",
  "Crane Driver",
];

export const IE_COUNTIES = [
  "Carlow", "Cavan", "Clare", "Cork", "Donegal", "Dublin", "Galway", "Kerry",
  "Kildare", "Kilkenny", "Laois", "Leitrim", "Limerick", "Longford", "Louth",
  "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon", "Sligo", "Tipperary",
  "Waterford", "Westmeath", "Wexford", "Wicklow",
];

export const UK_REGIONS = [
  // England
  "London", "Manchester", "Birmingham", "Leeds", "Liverpool", "Sheffield",
  "Bristol", "Newcastle", "Nottingham", "Leicester", "Southampton", "Portsmouth",
  "Brighton", "Coventry", "Milton Keynes", "Oxford", "Cambridge", "York",
  // Scotland
  "Glasgow", "Edinburgh", "Aberdeen", "Dundee",
  // Wales
  "Cardiff", "Swansea", "Newport",
  // Northern Ireland
  "Belfast", "Derry",
];

export const COUNTIES = [...IE_COUNTIES, ...UK_REGIONS];
export const COUNTRIES = ["Ireland", "United Kingdom"];

export function regionsForCountry(country) {
  if (country === "United Kingdom") return UK_REGIONS;
  return IE_COUNTIES;
}

export function countryForRegion(region) {
  if (UK_REGIONS.includes(region)) return "United Kingdom";
  return "Ireland";
}

export function currencyForRegion(region) {
  return UK_REGIONS.includes(region) ? "£" : "€";
}

export const DURATIONS = ["Weekend", "Week", "Month", "Ongoing"];

export const TRADE_ICONS = {
  Construction: "HardHat",
  "Steel Erector": "Hammer",
  Electrician: "Zap",
  "Truck Driver": "Truck",
  Plumber: "Wrench",
  Welder: "Flame",
};
